"use client";

import { useCallback, useRef } from "react";
import { Drawer, DrawerContent } from "@workspace/ui/components/drawer";
import { Dialog, DialogContent } from "@workspace/ui/components/dialog";
import { useModal } from "@/components/providers/modal-provider";
import { modalIds } from "./constants";
import { QuizRenderer } from "../quiz/quiz-renderer";
import { useMediaQuery } from "@/hooks/use-media-query";

export function QuizModal() {
  const { modalId, handleOpenModal, handleCloseModal, modalContent } = useModal();
  const isDesktop = useMediaQuery("(min-width: 640px)");
  const quizCompletedRef = useRef(false);

  const onQuizCompleted = useCallback((completed: boolean) => {
    quizCompletedRef.current = completed;
  }, []);

  const handleClose = useCallback(() => {
    if (quizCompletedRef.current) {
      handleCloseModal();
    } else {
      handleOpenModal(modalIds.quizExit, { returnToModalId: modalIds.quizQuestionnaire, touchpointType: modalContent?.touchpointType });
    }
  }, [handleCloseModal, handleOpenModal, modalContent?.touchpointType]);

  // On mobile, keep the quiz drawer mounted in the background while the exit
  // confirmation drawer is open so it remains visible behind it.
  const isOpen =
    modalId === modalIds.quizQuestionnaire ||
    (!isDesktop && modalId === modalIds.quizExit);

  const touchpointType = modalContent?.touchpointType;

  if (isDesktop) {
    return (
      <Dialog open={isOpen} onOpenChange={(open) => {
        if (!open) handleClose();
      }}>
        <DialogContent
          showCloseButton={false}
          className="!z-[52] p-0 overflow-hidden border bg-white rounded-2xl max-w-[500px] aspect-[436/714]"
          overlayClassName="!bg-transparent !backdrop-blur-none"
        >
          <QuizRenderer touchpointType={touchpointType} onQuizCompleted={onQuizCompleted} />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && modalId !== modalIds.quizExit) {
          handleClose();
        }
      }}
    >
      <DrawerContent
        className="!z-[52] p-0 border-none bg-white !rounded-t-2xl !max-h-[95dvh]"
        overlayClassName="!bg-transparent !backdrop-blur-none"
      >
        <QuizRenderer touchpointType={touchpointType} onQuizCompleted={onQuizCompleted} />
      </DrawerContent>
    </Drawer>
  );
}
